import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import logService from "../services/logging/logService";
import LoggerInitializer from "../components/LoggerInitializer";

function AuthLayout() {

  const bgUrl = new URL('../assets/images/bg_desktop_auth.png', import.meta.url).href;

  // Tracciamento navigazione per auth pages
  const location = useLocation();
  
  // Registra il cambiamento di pagina
  useEffect(() => {
    const currentPath = location.pathname;
    const pageName = currentPath === '/login' ? 'Login' : currentPath.split('/').pop();
    
    logService.logNavigation(
      currentPath,
      `Visitata pagina: ${pageName || currentPath}`,
      { 
        title: pageName,
        path: currentPath,
        search: location.search,
        hash: location.hash,
        isAuthPage: true
      }
    );
    console.log(`Auth page navigazione registrata: ${currentPath}`);
  }, [location.pathname, location.search]);

  return (
    <div className="min-h-screen h-full font-body" style={{ backgroundSize: 'contain', backgroundImage: `url(${bgUrl})` }}>
      <LoggerInitializer />
      <Outlet />
    </div>
  )
}

export default AuthLayout;
